// extracted by css-extract-rspack-plugin
export default {"filterCount":"filter-count--usduSXPcZZIdNJ9d"};